var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimulHomeBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179,
    height: 44,
    viewBox: "0 0 179 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Simul_home",
    "data-name": "Simul\\u2019home",
    transform: "translate(0 36)",
    fill: "#fff",
    fontSize: 36,
    fontFamily: "Lato-Light, Lato",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Simul\u2019home"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulHomeBlanc);
export default __webpack_public_path__ + "static/media/simul_home_blanc.12a15e7336fd1c0d96a8cb7576807f19.svg";
export { ForwardRef as ReactComponent };